import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { isMobile } from '@common/utils/device';
import { getPdfWorkerJsFile } from '@common/utils/pdfHelper';

const EaPdfViewer = props => {
  const { url, handlePageChange, pdfPageNum, jumpToPagePluginInstance } = props;

  // hanjy: jumpToPage 호출시 실행할 callback 등록
  jumpToPagePluginInstance.setJumpToPageCallback((pageIndex) => {
    handlePageChange({
      isCallback: true,
      currentPage: pageIndex + 1,
    });
  });

  return (
    <div className="con-wrap bg-gray">
      <div className="app-wrap pdf-area">
        <Worker
          workerUrl={getPdfWorkerJsFile(isMobile.any(), window.location.origin)}
        >
          <Viewer
            fileUrl={url}
            characterMap={{
              isCompressed: true,
              url: '/node_modules/pdfjs-dist/cmaps/',
            }}
            plugins={[jumpToPagePluginInstance]}
            onPageChange={e => handlePageChange(e)}
            initialPage={Number(pdfPageNum) - 1}
          />
        </Worker>
      </div>
    </div>
  );
};

export default EaPdfViewer;
